module.exports = __webpack_public_path__ + "img/14.0fd96940.jpg";